import _ from 'lodash'
import FetchManagementEmployee from 'utils/fetch/management/FetchManagementEmployee'
import { constantsActive, constantsGraphql } from 'utils/constants/constants'
import React, { useEffect, useState } from 'react'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import i18n from 'utils/i18n'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { listArrow } from 'styles/list'
import ListItem from 'components/atoms/ListItem'

const TeamEmployees = ({ team }) => {
	
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ employees, setEmployees ] = useState( [] )
	const [ search, setSearch ] = useState( '' )
	
	const fetchEmployees = () => {
		const teamNotExists = false;
		
		if( !_.isEmpty( team ) ) {
			FetchManagementEmployee.fetchAll( {
				teamGuid: !teamNotExists ? team.guid : '[empty]',
				variables: {
					visible_for_employees: constantsGraphql.YES_NO,
					verified: constantsGraphql.YES_NO,
					active: constantsGraphql.YES_NO,
				},
				callbackStart: setLoading.bind( this, true ),
				callbackError: setLoading.bind( this, false ),
				/* TODO optimize */
				callbackSuccess: ( {employees} ) => {
					setLoading( false )
					setEmployees( employees )
				},
				
			} );
		}
	}
	
	const openEmployee =  ( employee ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW, {
			employeeGuid: employee.guid,
			teamGuid: team?.guid,
		} );
	}
	
	const createEmployee = () => {
		openEmployee( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openEmployee }
			/>
		)
	}
	
	useEffect( () => {
		fetchEmployees()
	}, [] )
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.teams.team.input_search'),
					onChangeText: _.debounce( setSearch, 400 ),
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.EMPLOYEES ) ? { onPress: createEmployee } : null }
		/>
	);
	
	const filters = _.size( search ) > 2 ? [ { field: 'name', kind: 'contains', value: search } ] : null;
	
	return (
		<ManagementGroupedThemeList
			header={ header }
			items={ employees }
			renderItem={ renderItem.bind( this ) }
			groupByKey={ 'active' }
			filters={ filters }
			isSearching={ loading }
			groupByValues={ [
				constantsActive.YES,
				constantsActive.NO
			]}
		/>
	)
}

export default TeamEmployees
